import { TbCloudCog } from "react-icons/tb";

import { ComponentWithAs, IconProps } from "@chakra-ui/react";

import {
  ChartIcon,
  ClusterIcon,
  DocumentationIcon,
  LogoutIcon,
  TemplateIcon,
  TerminalIcon,
} from "@/components/shared/ReleaseIcons";

export const aiTopNavMenuItems = [
  { label: "AI Chat", icon: TerminalIcon, slug: "chat", pathname: "/workspaces/[workspaceId]/ai/chat" },
  {
    label: "AI Configurations",
    icon: TemplateIcon,
    slug: "ai_configurations",
    pathname: "/workspaces/[workspaceId]/ai/ai_configurations",
  },
  {
    label: "Integrations",
    icon: ChartIcon,
    slug: "integrations",
    pathname: "/workspaces/[workspaceId]/ai/integrations",
  },
  {
    label: "Cloud Integrations",
    icon: TbCloudCog as ComponentWithAs<"svg", IconProps>,
    slug: "cloud_integrations",
    pathname: "/workspaces/[workspaceId]/ai/cloud_integrations",
  },
  {
    label: "Clusters",
    icon: ClusterIcon,
    slug: "clusters",
    pathname: "/workspaces/[workspaceId]/ai/clusters",
  },
] as const;

export const aiBottomNavMenuItems = [
  {
    label: "Documentation",
    icon: DocumentationIcon,
    slug: "documentation",
    pathname: "https://docs.release.com/release-ai/introduction",
    external: true,
  },
  { label: "Log out", icon: LogoutIcon, slug: "logout", pathname: "/logout" },
] as const;

const allItems = [...aiTopNavMenuItems, ...aiBottomNavMenuItems] as const;
export type AiNavMenuItemSlug = (typeof allItems)[number]["slug"];
